import { z } from 'zod'
import { oc } from '@orpc/contract'
import {
  collectCredentialIssues,
  memberCredentialsSchema,
} from '../../practitioner/handlers/member-credentials.contract'

export {
  PRACTITIONER_QUALIFICATIONS,
  SPECIALTIES_BY_QUALIFICATION,
} from '../../practitioner/handlers/member-credentials.contract'

export const inviteOrgMemberInputSchema = memberCredentialsSchema
  .extend({
    organizationId: z.string().min(1),
    role: z.enum(['practitioner', 'scheduleManager']),
    firstName: z.string().min(1, 'First name is required'),
    lastName: z.string().min(1, 'Last name is required'),
    email: z.email('Invalid email address').min(1, 'Email is required'),
  })
  .refine(
    (data) =>
      data.role === 'practitioner' || (data.licenses.length === 0 && !data.professionalRole),
    {
      path: ['licenses'],
      message: 'Only practitioners can hold a Professional role or state licenses',
    },
  )
  .superRefine((data, ctx) => {
    for (const issue of collectCredentialIssues(data)) {
      ctx.addIssue({ code: 'custom', ...issue })
    }
  })

export type InviteOrgMemberInput = z.infer<typeof inviteOrgMemberInputSchema>

export const inviteOrgMemberOutputSchema = z.object({
  membershipId: z.string(),
  practitionerId: z.string(),
})

export const inviteOrgMember = oc
  .route({ method: 'POST', path: '/v2/super/organizations/{organizationId}/invite' })
  .input(inviteOrgMemberInputSchema)
  .output(inviteOrgMemberOutputSchema)
